module.exports = __webpack_public_path__ + "vu.svg?4acd098aefe4ed4e16453f4d669d247e";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/vu.svg
// module id = 1224
// module chunks = 27